import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costs } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-zinc-900 py-12 sm:py-14" aria-labelledby="problem-heading" data-id="element-152" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-153" data-mp="2vqhhgfgrdy1g">
        <SectionHeading eyebrow="Il problema reale" title={<span id="problem-heading" data-id="element-155" data-mp="39hvzaiyxjt6x">Ti suona familiare?</span>} data-id="element-154" data-mp="2vppl32fc7wa4" />

        <div className="mx-auto mt-9 max-w-3xl space-y-5 border-l-2 border-yellow-500/50 pl-6 sm:pl-8" data-id="element-156" data-mp="39g2sn3obh8yx">
          <p className="font-serif text-xl font-bold leading-snug text-stone-100 sm:text-2xl" data-id="element-157" data-mp="35g0wtb59j9rk">
            È lunedì pomeriggio alle 18:00. Arrivi in pista con 20 atleti:
            velocisti, ostacolisti, fondisti, saltatori e lanciatori. Tutti
            nello stesso spazio. Livelli diversi. Obiettivi diversi. E tu senza
            un piano chiaro per la sessione.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone-400" data-id="element-158" data-mp="1k4itepb65x3p">
            Hai passato tutta la domenica a cercare esercizi su YouTube,
            mettendo insieme cose da fonti diverse, cercando di dare loro
            coerenza. E a metà sessione ti accorgi che non c'è una vera
            progressione tra gli esercizi, che gli avanzati si annoiano, che i
            principianti non capiscono il gesto — e che hai speso 4 ore a
            pianificare qualcosa che sembra improvvisato.
          </p>
        </div>

        <div className="mt-12" data-id="element-159" data-mp="172pkf4su2ew9">
          <h3 className="text-center font-serif text-xl font-bold leading-snug text-stone-100 sm:text-2xl" data-id="element-160" data-mp="171mvh2f2mmiz">
            Il costo reale di non avere il sistema corretto
          </h3>

          <ul className="mt-7 grid gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="1g3w39kiyg1so">
            {costs.map(cost => <li key={cost.title} className="flex gap-3" data-id="element-162" data-mp="3dtnred59pb99">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-red-600/50 bg-red-600/15" aria-hidden="true" data-id="element-163" data-mp="3dviadlwzatap">
                  <XIcon className="h-3 w-3 text-red-400" strokeWidth={3} data-id="element-164" data-mp="p121093biznp" />
                </span>
                <span data-id="element-165" data-mp="k2h8kvub5k9t">
                  <span className="block font-sans text-[0.9rem] font-semibold leading-snug text-stone-100" data-id="element-166" data-mp="k30jhsljj8ec">
                    {cost.title}
                  </span>
                  <span className="mt-1.5 block font-sans text-[0.82rem] leading-relaxed text-stone-400" data-id="element-167" data-mp="tyah844wotmb">
                    {cost.detail}
                  </span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}